import AddNewCreateUserLinkButtonPresenter from "../NewCreateUserLink/AddNewCreateUserLinkButton/AddNewCreateUserLinkButtonPresenter";
import AddNewCreateUserLinkFormModal from "../NewCreateUserLink/AddNewCreateUserLinkFormModal/AddNewCreateUserLinkFormModal";
import CreateUserLinkFilter from "./CreateUserLinkFilter/CreateUserLinkFilter";
import CreateUserLinkListPresenter from "./CreateUserLinkList/CreateUserLinkListPresenter";

/**
 * CreateUserLinkList
 */
export const CreateUserLinkList = {
    List: CreateUserLinkListPresenter,
    AddNewBtnModal: AddNewCreateUserLinkFormModal,
    AddBtn:  AddNewCreateUserLinkButtonPresenter,
    Filter: CreateUserLinkFilter

}

export default CreateUserLinkList;